const QUESTIONS_BY_GRADE = {
  5: [
    { text: 'My sister ___ ten years old.', answers: [{ letter: 'А', text: 'am' }, { letter: 'Б', text: 'is', correct: true }, { letter: 'В', text: 'are' }, { letter: 'Г', text: 'be' }] },
    { text: '___ apple a day keeps the doctor away.', answers: [{ letter: 'А', text: 'A' }, { letter: 'Б', text: 'An', correct: true }, { letter: 'В', text: 'The' }, { letter: 'Г', text: 'Some' }] },
    { text: 'Look at ___ cats over there! They are so cute.', answers: [{ letter: 'А', text: 'this' }, { letter: 'Б', text: 'that' }, { letter: 'В', text: 'those', correct: true }, { letter: 'Г', text: 'it' }] },
    { text: 'There ___ two books on the table.', answers: [{ letter: 'А', text: 'is' }, { letter: 'Б', text: 'are', correct: true }, { letter: 'В', text: 'am' }, { letter: 'Г', text: 'be' }] },
    { text: "This is Tom's bag. It is ___ bag.", answers: [{ letter: 'А', text: 'he' }, { letter: 'Б', text: 'his', correct: true }, { letter: 'В', text: 'him' }, { letter: 'Г', text: "he's" }] },
    { text: 'My birthday is ___ May.', answers: [{ letter: 'А', text: 'in', correct: true }, { letter: 'Б', text: 'on' }, { letter: 'В', text: 'at' }, { letter: 'Г', text: 'to' }] },
    { text: 'What is the plural of "child"?', answers: [{ letter: 'А', text: 'childs' }, { letter: 'Б', text: 'childes' }, { letter: 'В', text: 'children', correct: true }, { letter: 'Г', text: 'childrens' }] },
    { text: 'What colour is the sky on a clear day?', answers: [{ letter: 'А', text: 'Green' }, { letter: 'Б', text: 'Blue', correct: true }, { letter: 'В', text: 'Red' }, { letter: 'Г', text: 'Purple' }] },
    { text: 'I have ___ dog and a cat.', answers: [{ letter: 'А', text: 'a', correct: true }, { letter: 'Б', text: 'an' }, { letter: 'В', text: 'some' }, { letter: 'Г', text: 'the' }] },
    { text: 'Choose the correct question word: "___ is your name?"', answers: [{ letter: 'А', text: 'What', correct: true }, { letter: 'Б', text: 'Who' }, { letter: 'В', text: 'Where' }, { letter: 'Г', text: 'When' }] },
  ],
  6: [
    { text: 'She ___ to school every day.', answers: [{ letter: 'А', text: 'walk' }, { letter: 'Б', text: 'walks', correct: true }, { letter: 'В', text: 'walking' }, { letter: 'Г', text: 'walked' }] },
    { text: 'We usually ___ breakfast at 7 o\'clock.', answers: [{ letter: 'А', text: 'has' }, { letter: 'Б', text: 'have', correct: true }, { letter: 'В', text: 'having' }, { letter: 'Г', text: 'had' }] },
    { text: "There isn't ___ milk in the fridge.", answers: [{ letter: 'А', text: 'some' }, { letter: 'Б', text: 'any', correct: true }, { letter: 'В', text: 'a' }, { letter: 'Г', text: 'an' }] },
    { text: 'My brother can ___ very fast.', answers: [{ letter: 'А', text: 'runs' }, { letter: 'Б', text: 'run', correct: true }, { letter: 'В', text: 'running' }, { letter: 'Г', text: 'to running' }] },
    { text: 'The cat is ___ the box.', answers: [{ letter: 'А', text: 'in', correct: true }, { letter: 'Б', text: 'at' }, { letter: 'В', text: 'to' }, { letter: 'Г', text: 'from' }] },
    { text: 'What time ___ you get up?', answers: [{ letter: 'А', text: 'do', correct: true }, { letter: 'Б', text: 'does' }, { letter: 'В', text: 'is' }, { letter: 'Г', text: 'are' }] },
    { text: "He doesn't like ___ vegetables.", answers: [{ letter: 'А', text: 'eat' }, { letter: 'Б', text: 'eats' }, { letter: 'В', text: 'eating', correct: true }, { letter: 'Г', text: 'ate' }] },
    { text: 'I usually go to bed ___ 10 pm.', answers: [{ letter: 'А', text: 'in' }, { letter: 'Б', text: 'on' }, { letter: 'В', text: 'at', correct: true }, { letter: 'Г', text: 'to' }] },
    { text: 'My parents ___ working today.', answers: [{ letter: 'А', text: "doesn't" }, { letter: 'Б', text: "isn't" }, { letter: 'В', text: "aren't", correct: true }, { letter: 'Г', text: "didn't" }] },
    { text: 'How ___ brothers do you have?', answers: [{ letter: 'А', text: 'much' }, { letter: 'Б', text: 'many', correct: true }, { letter: 'В', text: 'any' }, { letter: 'Г', text: 'some' }] },
  ],
  7: [
    { text: 'Yesterday we ___ to the cinema.', answers: [{ letter: 'А', text: 'go' }, { letter: 'Б', text: 'goes' }, { letter: 'В', text: 'went', correct: true }, { letter: 'Г', text: 'gone' }] },
    { text: 'This exercise is ___ than the last one.', answers: [{ letter: 'А', text: 'more easy' }, { letter: 'Б', text: 'easier', correct: true }, { letter: 'В', text: 'easiest' }, { letter: 'Г', text: 'easyer' }] },
    { text: 'What ___ you do last weekend?', answers: [{ letter: 'А', text: 'do' }, { letter: 'Б', text: 'did', correct: true }, { letter: 'В', text: 'were' }, { letter: 'Г', text: 'have' }] },
    { text: 'He was born ___ 2012.', answers: [{ letter: 'А', text: 'on' }, { letter: 'Б', text: 'at' }, { letter: 'В', text: 'in', correct: true }, { letter: 'Г', text: 'since' }] },
    { text: 'She is the ___ student in our class.', answers: [{ letter: 'А', text: 'good' }, { letter: 'Б', text: 'better' }, { letter: 'В', text: 'best', correct: true }, { letter: 'Г', text: 'goodest' }] },
    { text: 'Look! It ___ raining.', answers: [{ letter: 'А', text: 'is', correct: true }, { letter: 'Б', text: 'was' }, { letter: 'В', text: 'does' }, { letter: 'Г', text: 'did' }] },
    { text: 'I ___ my homework already.', answers: [{ letter: 'А', text: 'did' }, { letter: 'Б', text: 'have done', correct: true }, { letter: 'В', text: 'done' }, { letter: 'Г', text: 'do' }] },
    { text: "They didn't ___ the bus yesterday.", answers: [{ letter: 'А', text: 'caught' }, { letter: 'Б', text: 'catch', correct: true }, { letter: 'В', text: 'catches' }, { letter: 'Г', text: 'catching' }] },
    { text: 'See you ___ Monday.', answers: [{ letter: 'А', text: 'in' }, { letter: 'Б', text: 'on', correct: true }, { letter: 'В', text: 'at' }, { letter: 'Г', text: 'for' }] },
    { text: 'Which word means "very tired"?', answers: [{ letter: 'А', text: 'Excited' }, { letter: 'Б', text: 'Exhausted', correct: true }, { letter: 'В', text: 'Embarrassed' }, { letter: 'Г', text: 'Enormous' }] },
  ],
  8: [
    { text: 'I have never ___ sushi.', answers: [{ letter: 'А', text: 'eaten', correct: true }, { letter: 'Б', text: 'eat' }, { letter: 'В', text: 'ate' }, { letter: 'Г', text: 'eating' }] },
    { text: 'If it rains tomorrow, we ___ stay home.', answers: [{ letter: 'А', text: 'will', correct: true }, { letter: 'Б', text: 'would' }, { letter: 'В', text: 'can' }, { letter: 'Г', text: 'must' }] },
    { text: 'You ___ wear a seatbelt in the car.', answers: [{ letter: 'А', text: 'must', correct: true }, { letter: 'Б', text: 'can' }, { letter: 'В', text: 'might' }, { letter: 'Г', text: 'would' }] },
    { text: 'This cake ___ by my grandmother.', answers: [{ letter: 'А', text: 'made' }, { letter: 'Б', text: 'was made', correct: true }, { letter: 'В', text: 'is making' }, { letter: 'Г', text: 'make' }] },
    { text: 'She has lived here ___ 2015.', answers: [{ letter: 'А', text: 'for' }, { letter: 'Б', text: 'since', correct: true }, { letter: 'В', text: 'from' }, { letter: 'Г', text: 'at' }] },
    { text: 'If I ___ you, I would apologise.', answers: [{ letter: 'А', text: 'am' }, { letter: 'Б', text: 'was' }, { letter: 'В', text: 'were', correct: true }, { letter: 'Г', text: 'be' }] },
    { text: 'Have you ever ___ to Paris?', answers: [{ letter: 'А', text: 'be' }, { letter: 'Б', text: 'being' }, { letter: 'В', text: 'been', correct: true }, { letter: 'Г', text: 'was' }] },
    { text: 'The letter ___ tomorrow.', answers: [{ letter: 'А', text: 'sends' }, { letter: 'Б', text: 'will send' }, { letter: 'В', text: 'will be sent', correct: true }, { letter: 'Г', text: 'sent' }] },
    { text: '"___ you help me, please?" — a polite request.', answers: [{ letter: 'А', text: 'Must' }, { letter: 'Б', text: 'Could', correct: true }, { letter: 'В', text: 'Should' }, { letter: 'Г', text: 'Need' }] },
    { text: 'Which sentence is correct?', answers: [{ letter: 'А', text: "She don't like coffee." }, { letter: 'Б', text: "She doesn't likes coffee." }, { letter: 'В', text: "She doesn't like coffee.", correct: true }, { letter: 'Г', text: 'She not like coffee.' }] },
  ],
  9: [
    { text: 'While I ___ TV, the phone rang.', answers: [{ letter: 'А', text: 'watched' }, { letter: 'Б', text: 'was watching', correct: true }, { letter: 'В', text: 'have watched' }, { letter: 'Г', text: 'watch' }] },
    { text: 'He said that he ___ tired.', answers: [{ letter: 'А', text: 'is' }, { letter: 'Б', text: 'was', correct: true }, { letter: 'В', text: 'were' }, { letter: 'Г', text: 'be' }] },
    { text: 'The book ___ by millions of people.', answers: [{ letter: 'А', text: 'has read' }, { letter: 'Б', text: 'has been read', correct: true }, { letter: 'В', text: 'is reading' }, { letter: 'Г', text: 'read' }] },
    { text: 'This is the man ___ helped me yesterday.', answers: [{ letter: 'А', text: 'which' }, { letter: 'Б', text: 'who', correct: true }, { letter: 'В', text: 'whose' }, { letter: 'Г', text: 'whom' }] },
    { text: 'She asked me where I ___ from.', answers: [{ letter: 'А', text: 'am' }, { letter: 'Б', text: 'was', correct: true }, { letter: 'В', text: 'were' }, { letter: 'Г', text: 'be' }] },
    { text: 'By the time we arrived, the film ___.', answers: [{ letter: 'А', text: 'started' }, { letter: 'Б', text: 'has started' }, { letter: 'В', text: 'had started', correct: true }, { letter: 'Г', text: 'starts' }] },
    { text: 'Choose the correct passive form of: "They built this house in 1990."', answers: [{ letter: 'А', text: 'This house built in 1990.' }, { letter: 'Б', text: 'This house was built in 1990.', correct: true }, { letter: 'В', text: 'This house is built in 1990.' }, { letter: 'Г', text: 'This house has built in 1990.' }] },
    { text: 'I wish I ___ more time.', answers: [{ letter: 'А', text: 'have' }, { letter: 'Б', text: 'had', correct: true }, { letter: 'В', text: 'has' }, { letter: 'Г', text: 'having' }] },
    { text: "He's the person ___ car was stolen.", answers: [{ letter: 'А', text: 'who' }, { letter: 'Б', text: 'whose', correct: true }, { letter: 'В', text: 'which' }, { letter: 'Г', text: 'that' }] },
    { text: 'Choose the correct reported speech for: She asked, "Do you like tea?"', answers: [{ letter: 'А', text: 'She asked if I like tea.' }, { letter: 'Б', text: 'She asked if I liked tea.', correct: true }, { letter: 'В', text: 'She asked do I like tea.' }, { letter: 'Г', text: 'She asked if did I like tea.' }] },
  ],
  10: [
    { text: 'If I ___ rich, I would travel the world.', answers: [{ letter: 'А', text: 'am' }, { letter: 'Б', text: 'was' }, { letter: 'В', text: 'were', correct: true }, { letter: 'Г', text: 'be' }] },
    { text: 'If she had studied harder, she ___ the exam.', answers: [{ letter: 'А', text: 'would pass' }, { letter: 'Б', text: 'would have passed', correct: true }, { letter: 'В', text: 'will pass' }, { letter: 'Г', text: 'passed' }] },
    { text: 'I look forward to ___ from you.', answers: [{ letter: 'А', text: 'hear' }, { letter: 'Б', text: 'hearing', correct: true }, { letter: 'В', text: 'heard' }, { letter: 'Г', text: 'to hear' }] },
    { text: 'He denied ___ the money.', answers: [{ letter: 'А', text: 'to take' }, { letter: 'Б', text: 'taking', correct: true }, { letter: 'В', text: 'take' }, { letter: 'Г', text: 'took' }] },
    { text: 'The problem needs ___ immediately.', answers: [{ letter: 'А', text: 'solve' }, { letter: 'Б', text: 'solving', correct: true }, { letter: 'В', text: 'solved' }, { letter: 'Г', text: 'to solving' }] },
    { text: "She's used to ___ up early.", answers: [{ letter: 'А', text: 'get' }, { letter: 'Б', text: 'getting', correct: true }, { letter: 'В', text: 'got' }, { letter: 'Г', text: 'to get' }] },
    { text: 'Which phrasal verb means "to cancel"?', answers: [{ letter: 'А', text: 'Call off', correct: true }, { letter: 'Б', text: 'Call in' }, { letter: 'В', text: 'Call up' }, { letter: 'Г', text: 'Call out' }] },
    { text: 'Not only ___ late, but he also forgot the tickets.', answers: [{ letter: 'А', text: 'he arrived' }, { letter: 'Б', text: 'did he arrive', correct: true }, { letter: 'В', text: 'he did arrive' }, { letter: 'Г', text: 'arrived he' }] },
    { text: 'The bridge ___ next year.', answers: [{ letter: 'А', text: 'is going to be built', correct: true }, { letter: 'Б', text: 'builds' }, { letter: 'В', text: 'was built' }, { letter: 'Г', text: 'is build' }] },
    { text: '"I\'d rather you ___ that."', answers: [{ letter: 'А', text: "don't do" }, { letter: 'Б', text: "didn't do", correct: true }, { letter: 'В', text: 'not do' }, { letter: 'Г', text: "won't do" }] },
  ],
  11: [
    { text: 'The idiom "It\'s raining cats and dogs" means:', answers: [{ letter: 'А', text: "It's raining heavily", correct: true }, { letter: 'Б', text: 'Animals are falling from the sky' }, { letter: 'В', text: "It's a sunny day" }, { letter: 'Г', text: "It's snowing" }] },
    { text: 'Choose the correct mixed conditional: "If I had taken that job, I ___ in London now."', answers: [{ letter: 'А', text: 'would live' }, { letter: 'Б', text: 'would have lived' }, { letter: 'В', text: 'would be living', correct: true }, { letter: 'Г', text: 'will live' }] },
    { text: '"Rarely ___ such dedication."', answers: [{ letter: 'А', text: 'I have seen' }, { letter: 'Б', text: 'have I seen', correct: true }, { letter: 'В', text: 'I saw' }, { letter: 'Г', text: 'did I see' }] },
    { text: 'The idiom "to hit the books" means:', answers: [{ letter: 'А', text: 'To study hard', correct: true }, { letter: 'Б', text: 'To throw books' }, { letter: 'В', text: 'To read for fun' }, { letter: 'Г', text: 'To buy books' }] },
    { text: '"She\'d rather have stayed home ___ gone to the party."', answers: [{ letter: 'А', text: 'that' }, { letter: 'Б', text: 'than', correct: true }, { letter: 'В', text: 'then' }, { letter: 'Г', text: 'from' }] },
    { text: '"Despite ___ hard, he failed."', answers: [{ letter: 'А', text: 'study' }, { letter: 'Б', text: 'studied' }, { letter: 'В', text: 'to study' }, { letter: 'Г', text: 'studying', correct: true }] },
    { text: 'The idiom "to cost an arm and a leg" means:', answers: [{ letter: 'А', text: 'Very expensive', correct: true }, { letter: 'Б', text: 'Very cheap' }, { letter: 'В', text: 'Painful' }, { letter: 'Г', text: 'Free' }] },
    { text: 'Which sentence uses inversion correctly?', answers: [{ letter: 'А', text: 'I have never seen such chaos.' }, { letter: 'Б', text: 'Never have I seen such chaos.', correct: true }, { letter: 'В', text: 'Never I have seen such chaos.' }, { letter: 'Г', text: 'I never have seen such chaos.' }] },
    { text: 'Choose the best word: "The negotiations were ___, lasting for hours without resolution."', answers: [{ letter: 'А', text: 'protracted', correct: true }, { letter: 'Б', text: 'brief' }, { letter: 'В', text: 'swift' }, { letter: 'Г', text: 'abrupt' }] },
    { text: 'The idiom "bite the bullet" means:', answers: [{ letter: 'А', text: 'To face a difficult situation bravely', correct: true }, { letter: 'Б', text: 'To eat something hard' }, { letter: 'В', text: 'To shoot a gun' }, { letter: 'Г', text: 'To avoid a problem' }] },
  ],
};

const RESULTS = [
  { min: 0, max: 3, title: 'Морозиво? Легко!', text: 'Твоя англійська вже вирушила в подорож, а попереду багато часу, щоб вивчити нові слова і стати ще впевненішим(-ою)!' },
  { min: 4, max: 7, title: 'Готовий(-а) до нових знайомств!', text: 'З таким рівнем можна впевнено привітатися, поставити прості запитання та знайти друзів у будь-якій міжнародній подорожі.' },
  { min: 8, max: 10, title: 'Готовий(-а) до Лондона', text: 'Вау! Ти вже готовий(а) підкорювати Лондон і сказати "Hello!" так, ніби завжди там жив(ла).' },
];

const TOTAL = 10;

const state = {
  grade: null,
  currentIndex: 0,
  score: 0,
};

function getTrackingParams() {
  const params = new URLSearchParams(window.location.search);
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
  const result = {};
  keys.forEach((key) => {
    result[key] = params.get(key) || '';
  });
  return result;
}

const tracking = getTrackingParams();

const el = {
  intro: null,
  question: null,
  result: null,
  share: null,
  counter: null,
  progressIcons: null,
  questionText: null,
  answersList: null,
  scoreEl: null,
  resultTitle: null,
  resultText: null,
  challengeText: null,
  shareUrl: null,
};

function initElements() {
  el.intro = document.querySelector('.mnmt-screen--intro');
  el.question = document.querySelector('.mnmt-screen--question');
  el.result = document.querySelector('.mnmt-screen--result');
  el.share = document.querySelector('.mnmt-share-overlay');
  el.counter = document.querySelector('.mnmt-counter-text');
  el.progressIcons = document.querySelectorAll('.mnmt-en-progress__icon');
  el.questionText = document.querySelector('.mnmt-question-text');
  el.answersList = document.querySelector('.mnmt-answers-list');
  el.scoreEl = document.querySelector('.mnmt-result-score');
  el.resultTitle = document.querySelector('.mnmt-result-title');
  el.resultText = document.querySelector('.mnmt-result-text');
  el.challengeText = document.querySelector('.mnmt-challenge-text');
  el.shareUrl = document.querySelector('.mnmt-share-url');
}

function showScreen(name) {
  [el.intro, el.question, el.result].forEach((s) => {
    if (s) s.hidden = true;
  });
  const target = el[name];
  if (target) target.hidden = false;
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function renderQuestion(index) {
  const questions = QUESTIONS_BY_GRADE[state.grade] || QUESTIONS_BY_GRADE[5];
  const q = questions[index];
  const questionNumber = index + 1;

  if (el.counter) el.counter.textContent = questionNumber + '/' + TOTAL;

  el.progressIcons.forEach((icon, i) => {
    icon.classList.toggle('is-revealed', i < questionNumber);
  });

  el.questionText.innerHTML = q.text;

  el.answersList.innerHTML = '';
  q.answers.forEach((answer) => {
    const li = document.createElement('li');
    li.className = 'mnmt-answer-item';
    li.innerHTML =
      '<button class="mnmt-answer-btn" type="button">' +
      '<span class="mnmt-answer-circle"></span>' +
      '<span class="mnmt-answer-letter">' + answer.letter + '</span>' +
      '<span class="mnmt-answer-text">' + answer.text + '</span>' +
      '</button>';

    li.querySelector('.mnmt-answer-btn').addEventListener('click', () => {
      onAnswer(!!answer.correct);
    });

    el.answersList.appendChild(li);
  });
}

function onAnswer(isCorrect) {
  if (isCorrect) state.score += 1;
  state.currentIndex++;

  if (state.currentIndex < TOTAL) {
    renderQuestion(state.currentIndex);
  } else {
    showResult();
  }
}

function getResult() {
  return RESULTS.find((r) => state.score >= r.min && state.score <= r.max) || RESULTS[0];
}

function showResult() {
  const result = getResult();

  el.scoreEl.textContent = state.score;
  el.resultTitle.textContent = result.title;
  el.resultText.textContent = result.text;
  if (el.challengeText) el.challengeText.textContent = 'Кинь виклик друзям — перевір, хто з тобою їде до Лондона 🔥';

  showScreen('result');
  sendToKeyCRM();
}

function initShareLinks() {
  const url = 'https://pifagor-school.com.ua/english-mini-test-quiz/?utm_source=english_quiz&utm_medium=share';

  if (el.shareUrl) el.shareUrl.value = url;

  const copyBtn = document.querySelector('.mnmt-share-copy');
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      navigator.clipboard.writeText(url).then(() => {
        alert('Посилання скопійовано!');
      });
    });
  }

  const shareText = encodeURIComponent('Пройди міні-тест з англійської і перевір свій рівень! ');
  const encodedUrl = encodeURIComponent(url);

  const links = {
    threads: 'https://www.threads.net/share?url=' + encodedUrl,
    twitter: 'https://twitter.com/intent/tweet?url=' + encodedUrl + '&text=' + shareText,
    facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl,
    linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodedUrl,
    telegram: 'https://t.me/share/url?url=' + encodedUrl + '&text=' + shareText,
  };

  Object.entries(links).forEach(([network, href]) => {
    const btn = document.querySelector('.mnmt-share-social--' + network);
    if (btn) btn.href = href;
  });
}

function initShareToggle() {
  const openBtns = document.querySelectorAll('.mnmt-share-open');
  const closeBtn = document.querySelector('.mnmt-share-close');

  openBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (el.result) el.result.hidden = true;
      if (el.share) el.share.hidden = false;
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      if (el.share) el.share.hidden = true;
      if (el.result) el.result.hidden = false;
    });
  }
}

function startQuiz() {
  state.currentIndex = 0;
  state.score = 0;
  showScreen('question');
  renderQuestion(0);
}

function sendToKeyCRM() {
  const nonce = window.MiniEnglish && window.MiniEnglish.nonce ? window.MiniEnglish.nonce : '';
  const ajaxUrl = window.MiniEnglish && window.MiniEnglish.ajaxUrl ? window.MiniEnglish.ajaxUrl : '/wp-admin/admin-ajax.php';

  fetch(ajaxUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      action: 'mini_english_result',
      nonce: nonce,
      name: state.userName || '',
      phone: state.userPhone || '',
      klas: state.grade || '',
      score: state.score,
      ...tracking,
    }),
  });
}

function initFormCapture() {
  const introSection = document.querySelector('.mnmt-screen--intro');
  if (!introSection) return;

  introSection.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      const klasField = form.querySelector('[name="klas"]');
      if (klasField) {
        const match = String(klasField.value).match(/\d+/);
        state.grade = match ? parseInt(match[0], 10) : 5;
      }
      const nameField = form.querySelector('[name="your-name"]');
      if (nameField) state.userName = nameField.value;
      const phoneField = form.querySelector('[name="Phone_no_code"]');
      if (phoneField) state.userPhone = phoneField.value;
    },
    true,
  );

  document.addEventListener('wpcf7mailsent', (e) => {
    const form = e.target;
    if (!form.closest('.mnmt-screen--intro')) return;
    startQuiz();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.mnmt-screen--intro.mnmt-screen--english')) return;

  initElements();
  initFormCapture();
  initShareLinks();
  initShareToggle();
});
